import { Grid } from "@mui/material";
import React, { useState } from "react";
import { getLocalValue, IRoleMain, LoacalVariables, MasterPages } from "../../commonFunctions/CommonFunctions";
import WSDataGrid from "../../Components/DataGrid/WSDataGrid";

import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import { Header } from "../Header/Header";

import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";

export const HolidayList: React.FC<any> = React.memo(
    (props) => {
        const navigate = useNavigate();
        const source: any = {
            url: "NationalHoliday/all",
            page: 1,
            pageSize: 10,
            filter: [],
            sort: [],
            type: 'GET'
        };
        const { view, exports, edit, add, del } = getPermissions(MasterPages.Holidays, IRoleMain.Masters)
        const userType: any = getLocalValue(LoacalVariables.UserType);
        const [isPopupOpen, setPopupOpen] = useState(false);
        const [selectedId, setSelectedId] = useState<number | null>(null);
        const dispatch = useDispatch();
        const { showMessage } = useSnackbar();
        /**
         * converting data
         * @param data 
         * @returns 
         */
        const transFormData = (data: any) => {
            const newList: Array<any> = []
            data.map((item: any) => {
                const month = moment.utc().month();
                const year = moment.utc().year();
                // month === moment(item.date).month() && 
                if (year === moment(item.date).year()) {
                    newList.push({ name: item?.name, date: item?.date, id: item?.id, isPublicHoliday: item?.isPublicHoliday })
                }


            });
            return newList;
        };



        const columns: any[] = [
            {
                header: "Name",
                fieldName: "name",
                tooltip: true,
                sortable: true,
            },
            {
                header: "Date",
                fieldName: "date",
                type: 'date',
            },
            ...(edit && userType === 'admin' ? [{
                header: "Actions",
                fieldName: "actions",
                type: "action",
                actions: [edit ? "Edit" : undefined, del ? 'Delete' : undefined],
                actionCallback: (action: any, row: any) => handleAction(action, row),
            }] : []),
        ];


        /**
         * Edit function
         * @param action 
         * @param row 
         */
        const handleAction = (action: string, row: any) => {
            if (action === "Edit") {
                navigate(`/holiday/edit/${row?.id}`)
            } else if (action === 'Delete') {
                setSelectedId(row.id); // Set the ID of the row to be deleted
                setPopupOpen(true)
            }
        };

        const handleClick = () => {
            navigate('/holiday/create')
        }
        const handleDelete = (response: any) => {
            dispatch(resetDataComponent('holidayGrid'));
            showMessage(response?.message, response?.success ? 'success' : 'error')
        };

        return (
            <>
                <Header title="Holidays" type="simple" isDivider={true} />
                {(view || userType !== 'admin') ?
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <WSDataGrid
                                // transFormData={transFormData}
                                id="holidayGrid"
                                title="Holidays"
                                buttonStyle="Normal"
                                columns={columns}
                                source={source}
                                exportCsv={exports}
                                transFormData={transFormData}
                                showpagination={(add && userType === 'admin')}
                                addButton={(add && userType === 'admin') ? {} : undefined}
                                onAddButtonClick={handleClick}
                            />
                        </Grid>
                    </Grid>
                    : <PermissionDenied />}
                {selectedId !== null && <ConfirmationPopup
                    apiUrl={'NationalHoliday'}
                    id={selectedId}
                    confirmMessage="Are you sure you want to delete this item?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={handleDelete}
                />}
            </>
        );
    }
);




